import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";

export default function NotFound() {
  return (
    <div className="min-h-screen grid place-items-center bg-white px-6">
      <div className="text-center max-w-md">
        <div className="flex justify-center">
          <Logo size="lg" />
        </div>
        <div className="tj-gold-rule mx-auto mt-8" />
        <h1 className="font-display mt-6 text-4xl font-bold" style={{ color: "#0B2545" }}>
          Page not found
        </h1>
        <p className="mt-3 text-sm" style={{ color: "#475569" }}>
          The page you’re looking for doesn’t exist. Let’s get you back on track.
        </p>
        <Link to="/" className="inline-block mt-6">
          <Button className="h-11 px-6 text-white" style={{ background: "#0B2545" }} data-testid="not-found-home">
            Back to Request Service
          </Button>
        </Link>
      </div>
    </div>
  );
}
